module.exports = __webpack_public_path__ + "img/preview-light.59ee6ad0.png";